export function findLastIndexWhichContainsChildren(arr) {
    let lastIndexWithChildren = -1;
    for (let i = 1; i < arr.length; i++) {
        if (arr[i].children) {
            lastIndexWithChildren = i;
        }
    }
    return lastIndexWithChildren;
}
export function pushStepIntoSpecificIndex(arr, index, value) {
    arr.splice(index, 0, value);
}
export function updateCommentSteps(comment, isInitialize) {
    try {
        let step = this.steps.find(x => x.children[0].id === comment.id);
        if (!step) {
            const _selectedStep = [...this.writtenSteps, ...this.oralSteps, ...this.statusList].find(x => x.id === comment.status);
            if (_selectedStep !== undefined){
                const obj = {
                label: _selectedStep.value,
                index: this.steps.length,
                showButtons: true,
                children: [{
                    id: comment.id,
                    action_comment: comment.action_comment,
                    include_in_report: comment.include_in_report,
                    type: comment.status,
                    label: comment.action_comment,
                    statusable_id: comment.statusable_id,
                    statusable_type: comment.statusable_type,
                    applicant_files: isInitialize ? comment.applicant_files.map(x => {
                        return {
                            id: x.id,
                            name: x.file_name,
                            fileURL: x.file_path
                        }
                    }) : this.uploadedFile
                }]
            };
                pushStepIntoSpecificIndex(this.steps, 0, obj);
            }

        } else {
            step.children[0].action_comment = comment.action_comment;
            step.children[0].label = comment.action_comment;
        }
    } catch (exception) {
        console.error(exception)
    }
}